import {Store, Module, ActionContext} from "vuex";

interface MainState {
    campaign: any,
    giftPackage: any
}

class MainModule implements Module<MainState, any> {
    namespaced = true;
    state = {
        campaign: null,
        giftPackage: null
    };
    actions = {};
    mutations = {
        setCampaign(state: MainState, campaign: any) {
            state.campaign = campaign;
        },
        setPackage(state: MainState, giftPackage: any) {
            state.giftPackage = giftPackage;
        },

    };
}

const main = new MainModule();
export default main;